import React, { Component } from 'react';
import classNames from 'classnames';

export default class WelcomePanel extends Component {
  constructor(){
    super()
    this.state = { 
      title: 'Billy הוא כלי עזר לאתרי אינטרנט.',
      image: { src: '', alt: ''},
      content: `
        <p>תוכל להשתמש בו בכל רגע בלחיצה על כפתור הפתיחה ולבצע התאמות לאתר בו אתה גולש. </p>
        <p><b>Billy</b> יזכור את הגדרותייך בביקורך הבא ויבצע אותן באופן אוטומטי.</p>
      `,
      isHidden: false
     }
  }
  hideWelcomePanel(){
    this.setState(prevState => ({
      isHidden: true
    }))
  }
  render() {
    let { image, title, content, isHidden } = this.state;
    let welcomeClass = classNames({
      'billy_hide': isHidden
    })
    return (
      <div className={`billy-welcome-panel billy-box ${ welcomeClass }`}>
        <button className="billy-welcome-panel__close billy-button fi-billy fi-billy-close" 
                onClick={ () => this.hideWelcomePanel() } 
                aria-label="סגור חלון פתיח">
        </button>
        <div className="billy-welcome-panel__image">
          { image.src &&
            <img className="billy-image" src={ image.src } alt={ image.alt } />
          }
        </div>
        <div className="billy-welcome-panel__info">
          <h1 className="billy-welcome-panel__title">{ title }</h1>
          <div className="billy-welcome-panel__content" dangerouslySetInnerHTML={{__html: content}}></div>
        </div>
      </div>
    )
  }
}




// WEBPACK FOOTER //
// ./src/components/WelcomePanel/index.js